"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuxuryFoods = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var LuxuryFoods = (function (_super) {
    __extends(LuxuryFoods, _super);
    function LuxuryFoods() {
        return _super.call(this, {
            name: CardName_1.CardName.LUXURY_FOODS,
            cardType: CardType_1.CardType.AUTOMATED,
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.VENUS).tag(Tags_1.Tags.EARTH).tag(Tags_1.Tags.JOVIAN); }),
            metadata: {
                description: 'Requires that you have a Venus tag, an Earth tag and a Jovian tag.',
                cardNumber: 'T10',
                victoryPoints: 2,
            },
        }) || this;
    }
    ;
    LuxuryFoods.prototype.canPlay = function (player) {
        return player.checkMultipleTagPresence([Tags_1.Tags.VENUS, Tags_1.Tags.EARTH, Tags_1.Tags.JOVIAN]);
    };
    LuxuryFoods.prototype.play = function () {
        return undefined;
    };
    LuxuryFoods.prototype.getVictoryPoints = function () {
        return 2;
    };
    return LuxuryFoods;
}(Card_1.Card));
exports.LuxuryFoods = LuxuryFoods;
//# sourceMappingURL=LuxuryFoods.js.map